import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { StarbaseModalButton, StarbaseModalDialogService, StarbaseModalOptions, StarbaseModalTypes } from 'starbase-modal-dialog';
import { DataDisplayerBase } from '../data-displayer-base';
import { Battle } from '../models/battle';
import { BattleLink } from '../models/battleLink';

@Component({
  selector: 'app-battle-display',
  templateUrl: './battle-display.component.html',
  styleUrls: ['./battle-display.component.css']
})
export class BattleDisplayComponent extends DataDisplayerBase<BattleLink> {
  @Input() editable = false;
  @Output() removeAction = new EventEmitter<Battle>();

  constructor(private modalSvc: StarbaseModalDialogService) {
  super();
  }

  removeItem(battle: Battle) {
    this.enableConfirmRowModal('Are you sure you want to remove this Battle? This action can\'t be undone.',
                                    'Battle removed',
                                    'Battle not removed').subscribe(a => {
        if (a) {
          this.removeAction.emit(battle);
        }
    });
  }

  enableConfirmRowModal(msg: string, successMsg?: string, errorMsg?: string): Observable<boolean> {
    const m = new Observable<boolean>(obj => {
      const modal = new StarbaseModalOptions('Confirm', msg, [
        new StarbaseModalButton('Yes', () => {
          obj.next(true);
          this.modalSvc.closeModal(successMsg);
        }),
        new StarbaseModalButton('No', () => {
          obj.next(false);
          this.modalSvc.closeModal(errorMsg);
        }),
      ], StarbaseModalTypes.Warning);

      modal.dismissable = true;
      this.modalSvc.postModal(modal);
      });

      return m;
   }
}
